import { apiPost, getHostApi } from "../../apiWrapper";
import { isNullOrUndefined } from "../../storeFunctions";
import { _raiseDataChanged } from "./actions";
import { diagram } from "./initial";
import { _createExpandReqParams } from "./requests";

async function _reloadCounts() {
    var safeLeafs = [];
    var dangerLeafs = [];

    diagram.nodeDiagram.nodes.each(
        function (node) {
            if (isNullOrUndefined(node.data.RelationsCount)) {
                if (!node.data.IsDangerous) {
                    safeLeafs.push(node);
                } else {
                    dangerLeafs.push([node]);
                }
            }
        });

    let chunkedLeafs = []
    let size = 20;
    if (safeLeafs.length > 0) {
        for (let i = 0; i < safeLeafs.length; i += size) {
            chunkedLeafs.push(safeLeafs.slice(i, i + size))
        }

        if (dangerLeafs.length > 0) {
            chunkedLeafs = chunkedLeafs.concat(dangerLeafs);
        }

        chunkedLeafs.reduce((p, c) => { return p.then(() => _relationsCountCalculation(c)) }, Promise.resolve());
    }
}

function _relationsCountCalculation(nodes) {
    if (nodes.length <= 0) {
        return;
    }

    let orientedLevel = Math.max.apply(Math, nodes.map(function (n) { return n.data.OrientedLevel; }));
    let originalLevel = Math.max.apply(Math, nodes.map(function (n) { return n.data.OriginalLevel; }));
    let ids = nodes.map(a => a.data.EntityID);

    const filterParameters = _createExpandReqParams(ids, originalLevel, orientedLevel, [], null);

    return new Promise((resolve, reject) => {
        apiPost(`${getHostApi()}/api/charts/calculate-node-relations-count`, undefined, filterParameters,
            (r) => resolve({ data: r.data }),
            (e) => reject(console.log(e))
        );
    }).then((value) => _processUpdateRelationsCountData(value.data));
}

function _processUpdateRelationsCountData(datas) {
    datas.forEach(data => {
        let node = diagram.nodeDiagram.findNodeForKey(data.EntityId);
        if (!node)
            return;
        let nodeData = node.data;
        if (!nodeData)
            return;

        _raiseDataChanged(nodeData, "RelationsCount", data.RelationsCount);
        _raiseDataChanged(nodeData, "TotalRelationsCount", data.TotalRelationsCount);
        _raiseDataChanged(nodeData, "SystemLock", data.SystemLock);
        if (data.SystemLock)
            nodeData.IsLocked = true;
        _raiseDataChanged(nodeData, "RelatedEntities", data.RelatedEntities);

        _recalculateActualRelationsCount(node, false);
    });
}

function _recalculateActualRelationsCount(node, withLinked = true) {
    if (node == null || node === undefined)
        return;

    const nodeData = node.data;
    if (nodeData === null || nodeData === undefined)
        return;

    node.diagram.startTransaction("setActualRelationsCount");

    if (!nodeData.IsExpanded)
        _updateActualRelationsCount(node);

    if (withLinked) {
        var subTreeRootLinks = node.linksConnected;
        while (subTreeRootLinks.next()) {
            if (subTreeRootLinks.value.fromNode.data === node.data) {
                if (subTreeRootLinks.value.toNode.visible && !subTreeRootLinks.value.toNode.data.IsExpanded && subTreeRootLinks.value.toNode.data.RelationsCount > 0) {
                    _updateActualRelationsCount(subTreeRootLinks.value.toNode)
                }
            } else if (subTreeRootLinks.value.toNode.data === node.data) {
                if (subTreeRootLinks.value.fromNode.visible && !subTreeRootLinks.value.fromNode.data.IsExpanded && subTreeRootLinks.value.fromNode.data.RelationsCount > 0) {
                    _updateActualRelationsCount(subTreeRootLinks.value.fromNode)
                }
            }
        }
    }

    node.diagram.commitTransaction("setActualRelationsCount");
}

function _updateActualRelationsCount(node) {
    let nodeData = node.data;
    const newActualRelationsCount = _countNewActualRelationsCount(node);

    _raiseDataChanged(nodeData, "actualRelationsCount", newActualRelationsCount);
}

function _countNewActualRelationsCount(node) {
    const subTreeRootLinks = node.linksConnected;
    const nodeData = node.data;

    let visibleRelatedRelationsCount = 0;
    let visibleRelationsCount = 0;
    let relationsCount = 0;

    function countVisibleRelations(link) {
        if (link.visible && link.fromNode.visible && link.toNode.visible) {
            let subTreeNodeData = link.data;
            //only to my related entities
            if (nodeData.RelatedEntities) {
                nodeData.RelatedEntities.forEach(relEntity => {
                    if ((subTreeNodeData.ParentID === nodeData.EntityID && subTreeNodeData.ChildID === relEntity) || (subTreeNodeData.ParentID === relEntity && subTreeNodeData.ChildID === nodeData.EntityID)) {
                        visibleRelatedRelationsCount++;
                    }
                });
            }
            visibleRelationsCount++;
        }
    }

    while (subTreeRootLinks.next()) {
        //count visible relations
        countVisibleRelations(subTreeRootLinks.value);
        //count all relations
        relationsCount++;
    }

    //return maximum possible invisible relations from db relations or connected relations in diagram
    return Math.max(nodeData.RelationsCount - visibleRelatedRelationsCount, relationsCount - visibleRelationsCount, 0);
}

export { _reloadCounts, _recalculateActualRelationsCount };